<template>
    <article>

        <ul class="alert alert-warning">
            <li>You can select multiple items by holding "Ctrl" button and select with mouse.</li>
            <li>To switch off selection click on one of selected items while holding "Ctrl" button.</li>
            <li>To deselect all, simply choose one item and then deselect that same item.</li>
            <li>To select many in succession, you choose one item, move to last item and click it while holding <q>Shift</q> button.</li>
        </ul>

        <nav class="nav nav-tabs nav-justified" v-if="!isDisabled">

            <!-- Static units -->
            <a data-toggle="tab" role="tab" class="nav-item nav-link active" href="#waterSchemes">Piped water schemes</a>
            <a data-toggle="tab" role="tab" class="nav-item nav-link" href="#waterPumps">Boreholes</a>
            <a data-toggle="tab" role="tab" class="nav-item nav-link" href="#waterSprings">Protected springs</a>
            <a data-toggle="tab" role="tab" class="nav-item nav-link" href="#adminUnit">Administrative units</a>

            <!-- Auto-generated tab-section-links -->
            <a
                class="nav-item nav-link"
                v-for="item of entityKeyWordIndex"
                :href=" '#' + item "
                data-toggle="tab"
                role="tab" >
                {{ itemNameProcessor(item) }}
            </a>

        </nav>

        <div class="tab-content" v-if="!isDisabled">

            <!-- static part of filter -->
            <section id="waterSchemes" class="tab-pane active">
                <div class="form-group">
                    <label class="col-form-label">Select <q>piped water scheme{{ (preSelected === null) ? '(s)' : '' }}</q></label>
                    <select class="form-control border border-dark" v-model="selectedShemes" size="8" :multiple="preSelected === null" >
                        <option v-for="(item, index) of pipes" :value="item">{{ item.name }}</option>
                    </select>
                </div>
            </section>

            <section id="waterPumps" class="tab-pane">
                <div class="form-group">
                    <label class="col-form-label">Select <q>borehole{{ (preSelected === null) ? '(s)' : '' }}</q></label>
                    <select class="form-control border border-dark" v-model="selectedPumps" size="8" :multiple="preSelected === null" >
                        <option v-for="(item, index) of handPumps" :value="item">{{ item.name }}</option>
                    </select>
                </div>
            </section>

            <section id="waterSprings" class="tab-pane">
                <div class="form-group">
                    <label class="col-form-label">Select <q>protected spring{{ (preSelected === null) ? '(s)' : '' }}</q></label>
                    <select class="form-control border border-dark" v-model="selectedSprings" size="8" :multiple="preSelected === null" >
                        <option v-for="(item, index) of springs" :value="item">{{ item.name }}</option>
                    </select>
                </div>
            </section>

            <section id="adminUnit" class="tab-pane">
                <filter-select
                    :provinces="provinces"
                    :is-disabled="isDisabled"
                    :can-multiple="preSelected === null"
                    @selected="(item) => selectedAdministrativeUnits = item" >
                </filter-select>
            </section>

            <!-- dynamically generated sections -->
            <template v-for="keywordIndex of entityKeyWordIndex">
                <auto-gen-section
                    :items="generalEntities[keywordIndex]"
                    :key-word-index="keywordIndex"
                    :pre-selected="preSelected"
                    @gpeUpdate="(itemsArray) => responsiveAssignGPE(keywordIndex, itemsArray)" >
                </auto-gen-section>
            </template>

        </div>

        <div class="btn btn-block btn-danger border border-dark my-1" @click="clearSelectedItems()"  v-if="!isDisabled"> Clear all selection </div>

        <div class="alert alert-info text-justify">
            <p>You have selected item(s) named:</p>
            <div class="d-inline" v-for="(item, numericIndex) of selectedItem">
                <span class="badge badge-secondary">{{ numericIndex + 1 + '.' }}</span> {{ item.name }}
            </div>
        </div>

        <input type="hidden" name="entity_id" :value="entityId">
        <input type="hidden" name="entity_type" :value="entityType">

    </article>
</template>

<script>

import HierarchicalGeoUnitSelect from "./AdministrativeUnitsFilterAndSelect.vue";
import AutoGenTabSection from "./TabSectionWithFilterAndSelect.vue"

export default{
    components : {
        "filter-select" : HierarchicalGeoUnitSelect,
        "auto-gen-section" : AutoGenTabSection
    },

    props : {

        generalEntities : {
            type : Object,
            required : true
        },

        entityKeyWordIndex : {
            type : Array,
            required : true
        },

        pipes : {
            type : Array,
            required : true,
        },

        handPumps : {
            type : Array,
            required : true,
        },

        springs : {
            type : Array,
            required : true,
        },

        provinces : {
            type : Array,
            required : true
        },

        isDisabled : {
            type : Boolean,
            default : false
        },

        preSelected : {
            type : Object,
            default : null
        }

    },

    
    data(){
        return {
            selectedGPE : {},
            selectedAdministrativeUnits : [],
            selectedShemes : [],
            selectedPumps : [],
            selectedSprings : [],
            selectedItem : []
        };
    },

    mounted(){
        // Export of [entity_id, entity_type] properties of data-set
        let something = (this.preSelected != null) ? this.preSelected : {entity_id : 0, entity_type : ""};

        this.findPreSelectedItem(something);
    },

    computed : {

        entityId(){
            return this.commonExtractor("id");
        },

        entityType(){
            return this.commonExtractor("model");
        }

    },

    watch : {

        // Problem is this is Object, and has arrays under keywords, so can't use this.commonExtractor(ArrayName)
        selectedGPE(){
            ((this.preSelected === null) ? this.commonArrayUnification() : this.selectedItem = [this.selectedGPE.lastSelected]);
        },

        selectedAdministrativeUnits(){
            this.commonSelect("AdministrativeUnits");
        },

        selectedShemes(){
            this.commonSelect("Shemes");
        },

        selectedPumps(){
            this.commonSelect("Pumps");
        },

        selectedSprings(){
            this.commonSelect("Springs");
        }

    },

    methods : {

        findPreSelectedItem(entityObject){
            switch (entityObject.entity_type){
                case "App\\Province" : { this.commonSearch("provinces", entityObject.entity_id); break; }
                case "App\\District" : { this.commonServerAjaxSearch("district", entityObject.entity_id); break; }
                case "App\\Sector" : { this.commonServerAjaxSearch("sector", entityObject.entity_id); break; }
                case "App\\Cell" : { this.commonServerAjaxSearch("cell", entityObject.entity_id); break; }
                case "App\\Village" : { this.commonServerAjaxSearch("village", entityObject.entity_id); break; }
                case "App\\Scheme" : { this.commonSearch("pipes", entityObject.entity_id); break; }
                case "App\\HandPump" : { this.commonSearch("handPumps", entityObject.entity_id); break; }
                case "App\\ImprovedSpring" : { this.commonSearch("springs", entityObject.entity_id); break; }
                case "App\\GeneralEntity" : { this.generalEntitiesSearch(entityObject.entity_id); break; }
            }
        },

        /* Simple common unification in order with Institutions first and soo on. */
        commonArrayUnification(){
            let temp = [];

            this.selectedItem = temp.concat(this.selectedShemes, this.selectedPumps, this.selectedSprings, this.selectedAdministrativeUnits);

            for (let keywordIndex of this.entityKeyWordIndex){
                if (this.selectedGPE[keywordIndex] != null) this.selectedItem = this.selectedItem.concat(this.selectedGPE[keywordIndex]);
            }
        },

        /* Common selection for watch-ed arguments, switching between single select, and multiple cases. */
        commonSelect(reference){
            ((this.preSelected === null) ? this.commonArrayUnification() : this.selectedItem = [this["selected" + reference]]);
        },

        /* Common pre-selection with search for pre-selected object. Common code from findPreSelectedItem() method */
        commonSearch(reference, identityNumber){
            window.console.info("search was triggered");
            if (identityNumber > 0){
                this.selectedItem = this[reference].filter((item) => { return item.id === identityNumber; });
            }
        },

        /* Common pre-selection with no search at all. Search of administrative-unit is done server-side and result returned.
           Common code from findPreSelectedItem() method. */
        commonServerAjaxSearch(reference, identityNumber, slug = false){
            if (identityNumber > 0){
                let address = "";
                if (slug){
                    address = APP_URL + "/data-collection/general-entity/" + identityNumber;
                } else {
                    address = APP_URL + "/administrative-units/" + reference + "/findUnit/" + identityNumber;
                }

                axios.get(address).then((response) => {
                    this.selectedItem.push(response.data);
                })
                .catch((error) => { window.console.error(error); });
            }
        },

        commonExtractor(reference){
            let emptyArray = [];
            if (this.selectedItem.length > 0) emptyArray = this.selectedItem.map((item) => { return item[reference]; });
            this.$emit("change:" + reference, emptyArray);
            return emptyArray;
        },

        responsiveAssignGPE(keywordIndex, newItemsArray){
            this.selectedGPE[keywordIndex] =  newItemsArray;
            this.selectedGPE = Object.assign({}, this.selectedGPE, { "lastSelected" : newItemsArray });
        },

        itemNameProcessor(value){
            let nameParts = value.split('-');
            nameParts[0] = nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1);
            return nameParts.join(' ');
        },

        /* Happens when dataset has data and sub component TabSectionWithFilterAndSelect is not even loaded */
        generalEntitiesSearch(identity){
            if (!this.isDisabled) return;

            let keyWordIndex;
            let subArray;
            let entity;

            for (keyWordIndex of this.entityKeyWordIndex){
                entity = this.generalEntities[keyWordIndex].find((item) => { return (item.id === identity); });

                if (entity != null) this.selectedItem.push(entity);
            }
        },

        clearSelectedItems(){
            this.selectedShemes = [];
            this.selectedPumps = [];
            this.selectedSprings = [];
            for (let subComponent of this.$children){ subComponent.clearSelectedItems(); }
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/data-set/DataSetWrapper.vue